import { useSoyuzData } from '@spotahome/soyuz/client';

import {
  AppBanner,
  CitiesProvider,
  CookiesProvider,
  FooterSimplified,
  GoogleOneTap,
  ThemeProvider,
  ToastContainer,
  UserInfoProvider
} from '@spotahome/ui-library';
import ZohoChatbot from '@spotahome/ui-library/src/tenant/components/ZohoChatbot/ZohoChatbot';

// Styles
import '@spotahome/landings-common/src/scss/init.scss';

import HeaderContainer from '@spotahome/landings-common/src/components/HeaderContainer';
import LazyLoginSignUpModal from '@spotahome/landings-common/src/components/LoginSignupModal';

import Content from './components/Content';

// Styles
import './main.scss';

const ContactUsContainer = () => {
  const { [ContactUsContainer.NAME]: requestedData } = useSoyuzData();
  const { deviceType, deviceViewType, initialCookie, asWebView, userId } =
    requestedData;

  return (
    <CookiesProvider initialCookie={initialCookie}>
      <ThemeProvider flags={{ newButtons: true }}>
        <UserInfoProvider>
          <CitiesProvider skipAllCities>
            <ToastContainer />
            {!userId && <GoogleOneTap />}
            {!asWebView && <AppBanner source="home" deviceType={deviceType} />}
            <ZohoChatbot />
            <div className="contact-us">
              <div className="contact-us__header-container">
                {!asWebView ? <HeaderContainer color="light" /> : null}
              </div>

              <Content />
              {!asWebView && <FooterSimplified />}
              <LazyLoginSignUpModal deviceViewType={deviceViewType} />
            </div>
          </CitiesProvider>
        </UserInfoProvider>
      </ThemeProvider>
    </CookiesProvider>
  );
};

ContactUsContainer.NAME = 'ContactUs';

ContactUsContainer.requestData = async (req, _, { res }) => {
  const isPartnerDeploy = req.brandConfig.isPartner;
  // This behavior is only for demo pruposes
  // We may want to change this into a handler in the future
  if (isPartnerDeploy) {
    return res.redirect(302, 'https://rentout.spotahome.com/partners/global');
  }

  return {
    data: {
      asWebView: req.query.as === 'web-view',
      deviceType: req.device.type,
      deviceViewType: req.device.viewType,
      initialCookie: req.headers.cookie,
      userId: req.userId
    }
  };
};

export default ContactUsContainer;
